(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hanging-collection-rail"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hanging-collection-rail')) return;
  class HangingCollectionRail extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.mount());
    }
    disconnectedCallback() {
      this.ready = false;
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.turnFrame);
      cancelAnimationFrame(this.rebaseFrame);
      clearTimeout(this.scrollTimer);
      clearInterval(this.timer);
      this.finishEntrance();
      this.cancelGlide();
      this.stopSwing();
      this.clearMobileLayout();
      this.abort?.abort();
      this.resize?.disconnect();
      this.visibility?.disconnect();
      this.loadVersion = (this.loadVersion || 0) + 1;
      this.close(true);
      this.ready = false;
    }
    mount() {
      if (this.ready || !this.isConnected) return;
      this.items = [...this.querySelectorAll('[data-rail-item]')];
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.items.length) return;
      this.ready = true;
      this.abort = new AbortController();
      this.labels = JSON.parse(this.dataset.labels);
      this.config = JSON.parse(this.dataset.config);
      this.viewport = this.querySelector('[data-viewport]');
      this.controls = this.querySelector('[data-controls]');
      this.dots = this.querySelector('[data-dots]');
      this.dots.replaceChildren();
      this.status = this.querySelector('[data-status]');
      this.image = this.querySelector('[data-detail-image]');
      this.addButton = this.querySelector('[data-add]');
      this.form = this.querySelector('[data-form]');
      this.cache = new Map();
      this.index = 0;
      this.loadVersion = 0;
      this.media = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.dataset.reduced = String(this.media.matches);
      this.paused = false;
      this.inView = false;
      this.entered = false;
      this.entranceAnimations = [];
      this.springs = this.items.map((item,index)=>({node:item.querySelector('.hr__suspension'),angle:0,velocity:0,index}));
      this.stopSwing();
      this.keyboardMode = false;
      this.listen(this.media, 'change', () => {
        this.dataset.reduced = String(this.media.matches);
        if (!this.motion()) {
          this.finishEntrance();
          this.cancelGlide();
          this.stopSwing();
        }
        this.updateMobileViews();
        this.updateControls();
      });
      this.listen(this.mobile, 'change', () => {
        this.cancelGlide();
        this.stopSwing();
        this.layoutMobile();
        this.findActive();
        this.updateControls();
      });
      this.items.forEach((item, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hr__dot';
        dot.dataset.go = String(index);
        dot.setAttribute('aria-label', `${this.labels.show} ${item.getAttribute('aria-label')}`);
        this.dots.append(dot);
        this.listen(item, 'pointermove', event => this.sway(item, event));
        this.listen(item, 'pointerleave', () => this.settle(item));
      });
      this.listen(this, 'click', event => this.onClick(event));
      this.listen(document, 'keydown', event => { if(event.key==='Tab') this.keyboardMode=true; });
      this.listen(this, 'pointerdown', () => {
        this.keyboardMode=false;
        this.focused=false;
        this.resetTimer();
      }, {capture:true});
      this.listen(this.viewport, 'pointerdown', event => {
        this.finishEntrance();
        this.cancelGlide();
        this.pointerStart = {x:event.clientX,y:event.clientY};
        this.dragged = false;
        this.interacting = true;
        this.resetTimer();
      });
      this.listen(this.viewport, 'pointermove', event => {
        if (this.pointerStart && Math.hypot(event.clientX-this.pointerStart.x,event.clientY-this.pointerStart.y)>8) this.dragged = true;
      });
      this.listen(window, 'pointerup', () => {
        this.pointerStart = null;
        this.interacting = false;
        this.resetTimer();
      });
      this.listen(window, 'pointercancel', () => {
        this.pointerStart = null;
        this.interacting = false;
        this.resetTimer();
      });
      this.listen(this.viewport, 'scroll', () => {
        this.scrolling=true;
        clearInterval(this.timer);
        this.startSwing();
        if(this.mobileLayout && !this.turnFrame) this.turnFrame=requestAnimationFrame(()=>{
          this.turnFrame=null;
          this.updateMobileViews();
        });
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          this.scrolling=false;
          this.findActive();
          this.resetTimer();
        }, 120);
      }, {passive:true});
      this.listen(this.viewport, 'keydown', event => {
        if(event.key===' ' && event.target===this.viewport && this.config.autoplay) {
          event.preventDefault();
          this.paused=!this.paused;
          if(!this.paused) this.focused=false;
          this.querySelector('[data-autoplay-status]').textContent=this.paused?this.labels.autoplay_paused:this.labels.autoplay_running;
          this.resetTimer();
          return;
        }
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        this.keyboardMode=true;
        this.focused=true;
        const focusedIndex = this.items.indexOf(document.activeElement);
        const current = focusedIndex >= 0 ? focusedIndex : this.index;
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.items.length-1 : current+(event.key==='ArrowRight'?1:-1);
        const index = Math.max(0,Math.min(this.items.length-1,next));
        this.go(index);
        this.items[index].focus({preventScroll:true});
      });
      this.listen(this.viewport, 'wheel', () => { this.cancelGlide(); this.resetTimer(); }, {passive:true});
      this.listen(this, 'pointerenter', event => { if(event.pointerType==='mouse') { this.hovered=true; this.resetTimer(); } });
      this.listen(this, 'pointerleave', () => { this.hovered=false; this.resetTimer(); });
      this.listen(this, 'focusin', () => { this.finishEntrance(); this.focused=this.keyboardMode; this.resetTimer(); });
      this.listen(this, 'focusout', event => { this.focused=this.keyboardMode&&this.contains(event.relatedTarget); this.resetTimer(); });
      this.listen(document, 'visibilitychange', () => {
        if(document.hidden) { this.finishEntrance(); this.cancelGlide(); this.stopSwing(); }
        this.resetTimer();
      });
      this.listen(this.dialog, 'cancel', event => { event.preventDefault(); this.close(); });
      this.listen(this.dialog, 'close', () => this.unlock());
      this.listen(this.form, 'submit', event => { event.preventDefault(); this.addToCart(); });
      this.listen(this.form, 'change', () => this.updateVariant());
      this.listen(this.image, 'error', () => { this.message(this.labels.image_error,true); });
      this.listen(document, 'hanging-rail:opening', event => { if(event.detail.source!==this) this.close(true); });
      this.listen(document, 'shopify:block:select', event => {
        const item = this.items.find(el => el.dataset.blockId===event.detail.blockId);
        if(!item) return;
        this.finishEntrance();
        this.editorSelected=true;
        this.resetTimer();
        this.go(this.items.indexOf(item));
        item.classList.add('is-preview');
      });
      this.listen(document, 'shopify:block:deselect', event => {
        this.items.find(el=>el.dataset.blockId===event.detail.blockId)?.classList.remove('is-preview');
        this.editorSelected=false;
        this.resetTimer();
      });
      this.resize = new ResizeObserver(() => { this.layoutMobile(); this.updateControls(); });
      this.resize.observe(this.viewport);
      this.layoutMobile();
      this.visibility = new IntersectionObserver(entries => {
        this.inView=entries[0].isIntersecting;
        if(this.inView) this.startEntrance();
        else { this.finishEntrance(); this.cancelGlide(); this.stopSwing(); }
        this.resetTimer();
      },{threshold:.1});
      this.visibility.observe(this.viewport);
      this.setDot(this.index);
      this.findActive();
      this.updateControls();
    }
    listen(target, type, callback, options={}) {
      target.addEventListener(type,callback,{...options,signal:this.abort.signal});
    }
    motion() { return this.config?.motion && !this.media?.matches; }
    layoutMobile() {
      const enabled=this.mobile.matches && this.config.mobileCenter===true;
      if(!enabled) {
        if(this.mobileLayout) {
          this.clearMobileLayout();
          this.viewport.scrollLeft=0;
        }
        return;
      }
      const width=this.viewport.clientWidth;
      if(!width || (this.mobileLayout && Math.abs(width-this.mobileWidth)<.5)) return;
      this.finishEntrance();
      this.cancelGlide();
      this.stopSwing();
      this.mobileWidth=width;
      this.mobilePitch=width/3;
      this.mobileLoop=this.items.length>=3;
      if(!this.mobileLayout) {
        const track=this.querySelector('.hr__track');
        this.mobileLayout=true;
        this.classList.add('is-mobile-center');
        this.items.forEach((item,index)=>{item.dataset.mobileIndex=String(index);});
        if(this.mobileLoop) {
          const clone=index=>{
            const slot=this.items[index].closest('.hr__slot').cloneNode(true);
            slot.dataset.mobileClone='';
            slot.setAttribute('aria-hidden','true');
            slot.removeAttribute('data-shopify-editor-block');
            slot.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
            slot.querySelectorAll('a,button,input,[tabindex]').forEach(el=>el.setAttribute('tabindex','-1'));
            slot.querySelector('[data-rail-item]').removeAttribute('data-block-id');
            return slot;
          };
          // Two neighbours at each end keep three garments visible while wrapping.
          track.prepend(clone(this.items.length-2),clone(this.items.length-1));
          track.append(clone(0),clone(1));
        }
        this.mobileItems=[...track.querySelectorAll('[data-rail-item]')];
        this.springs=this.mobileItems.map((item,index)=>({
          node:item.querySelector('.hr__suspension'),angle:0,velocity:0,
          index:Number(item.dataset.mobileIndex) || index
        }));
        if(!this.mobileHasStarted) {
          this.index=this.mobileLoop?1:0;
          this.mobileHasStarted=true;
        }
      }
      const largestFront=Math.max(...this.items.map(item=>{
        const ratio=parseFloat(item.style.getPropertyValue('--hr-front-ratio'))||.7;
        const scale=parseFloat(item.style.getPropertyValue('--hr-scale'))||1;
        return ratio*scale;
      }));
      this.style.setProperty('--hr-mobile-pitch',`${this.mobilePitch}px`);
      this.style.setProperty('--hr-mobile-inset',this.mobileLoop?'0px':`${this.mobilePitch}px`);
      this.style.setProperty('--hr-mobile-fit',String(Math.min(2.2,1.42/largestFront)));
      this.viewport.classList.add('is-rebasing');
      this.viewport.scrollLeft=(this.index+(this.mobileLoop?1:0))*this.mobilePitch;
      this.lastSwingLeft=this.viewport.scrollLeft;
      this.updateMobileViews();
      this.setDot(this.index);
      cancelAnimationFrame(this.rebaseFrame);
      this.rebaseFrame=requestAnimationFrame(()=>this.viewport?.classList.remove('is-rebasing'));
    }
    clearMobileLayout() {
      this.querySelectorAll('[data-mobile-clone]').forEach(slot=>slot.remove());
      this.classList.remove('is-mobile-center');
      this.items?.forEach(item=>{
        delete item.dataset.mobileIndex;
        delete item.dataset.mobileFront;
        ['--hr-front-alpha','--hr-side-alpha','--hr-front-turn','--hr-side-turn'].forEach(key=>item.style.removeProperty(key));
      });
      this.style.removeProperty('--hr-mobile-pitch');
      this.style.removeProperty('--hr-mobile-inset');
      this.style.removeProperty('--hr-mobile-fit');
      this.mobileItems=null;
      this.mobileLayout=false;
      this.mobileWidth=0;
      this.springs=this.items?.map((item,index)=>({node:item.querySelector('.hr__suspension'),angle:0,velocity:0,index}));
      this.viewport?.classList.remove('is-rebasing');
    }
    updateMobileViews() {
      if(!this.mobileLayout || !this.mobilePitch) return;
      const center=this.viewport.scrollLeft+this.viewport.clientWidth/2;
      const padding=this.mobileLoop?0:this.mobilePitch;
      const nearestPhysical=Math.max(0,Math.min(this.mobileItems.length-1,Math.round((center-padding)/this.mobilePitch-.5)));
      this.mobileItems.forEach((item,index)=>{
        const distance=(padding+(index+.5)*this.mobilePitch-center)/this.mobilePitch;
        const progress=Math.max(0,1-Math.abs(distance));
        const turn=this.motion()?progress*progress*(3-2*progress):(index===nearestPhysical?1:0);
        const direction=distance<0?-1:1;
        item.style.setProperty('--hr-front-alpha',turn.toFixed(3));
        item.style.setProperty('--hr-side-alpha',(1-turn).toFixed(3));
        item.style.setProperty('--hr-front-turn',`${(-65*(1-turn)*direction).toFixed(2)}deg`);
        item.style.setProperty('--hr-side-turn',`${(65*turn*direction).toFixed(2)}deg`);
        item.dataset.mobileFront=String(turn>.98);
      });
      this.setDot(Number(this.mobileItems[nearestPhysical].dataset.mobileIndex));
    }
    normalizeMobileLoop() {
      if(!this.mobileLayout || !this.mobileLoop || this.interacting) return;
      const physical=Math.round((this.viewport.scrollLeft+this.viewport.clientWidth/2)/this.mobilePitch-.5);
      if(physical>=2 && physical<this.items.length+2) return;
      const direction=physical<2?1:-1;
      const jump=direction*this.items.length*this.mobilePitch;
      this.viewport.classList.add('is-rebasing');
      this.viewport.scrollLeft+=jump;
      this.lastSwingLeft=this.viewport.scrollLeft;
      this.updateMobileViews();
      cancelAnimationFrame(this.rebaseFrame);
      this.rebaseFrame=requestAnimationFrame(()=>this.viewport?.classList.remove('is-rebasing'));
    }
    startEntrance() {
      if(this.entered) return;
      this.entered=true;
      if(!this.motion() || this.config.entrance===false || window.Shopify?.designMode) return;
      const view=this.viewport.getBoundingClientRect();
      const visible=(this.mobileItems||this.items).filter(item=>{
        const rect=item.getBoundingClientRect();
        return rect.right>view.left && rect.left<view.right;
      });
      if(!visible.length || typeof visible[0].animate!=='function') return;
      this.entering=true;
      const duration=Number(this.config.entranceDuration)||850;
      const stagger=Number(this.config.entranceStagger ?? 80);
      const distance=Number(this.config.entranceDistance ?? 64);
      const swing=Number(this.config.entranceSwing ?? 6);
      const animations=[];
      visible.forEach((item,index)=>{
        // Animate the slot separately so hover width and hanger alignment stay intact.
        const delay=Math.min(index*stagger,700);
        animations.push(item.closest('.hr__slot').animate([
          {transform:`translateY(${-distance}px)`,opacity:0,offset:0},
          {transform:'translateY(3px)',opacity:1,offset:.65},
          {transform:'translateY(0)',opacity:1,offset:1}
        ],{duration,delay,fill:'backwards',easing:'cubic-bezier(.22,.7,.25,1)'}));
        const angle=(index%2===0?-1:1)*swing;
        animations.push(item.querySelector('.hr__hanger').animate([
          {transform:`rotate(${angle}deg)`,offset:0},
          {transform:`rotate(${-angle*.38}deg)`,offset:.55},
          {transform:`rotate(${angle*.12}deg)`,offset:.8},
          {transform:'rotate(0deg)',offset:1}
        ],{duration:duration+250,delay,fill:'backwards',easing:'ease-out'}));
      });
      this.entranceAnimations=animations;
      Promise.allSettled(animations.map(animation=>animation.finished)).then(()=>{
        if(this.entranceAnimations!==animations) return;
        this.finishEntrance();
        this.resetTimer();
      });
    }
    finishEntrance() {
      this.entranceAnimations?.forEach(animation=>animation.cancel());
      this.entranceAnimations=[];
      this.entering=false;
    }
    sway(item,event) {
      if(!this.motion() || this.entering || event.pointerType!=='mouse' || this.mobile.matches) return;
      const rect=item.getBoundingClientRect();
      const angle=((event.clientX-rect.left)/rect.width-.5)*this.config.sway*2;
      item.querySelector('.hr__hanger').style.setProperty('--hr-sway',`${angle}deg`);
    }
    settle(item) {
      if(this.mobileLayout) return;
      const hanger=item.querySelector('.hr__hanger');
      const angle=parseFloat(hanger.style.getPropertyValue('--hr-sway'))||0;
      hanger.style.setProperty('--hr-sway','0deg');
      if(this.motion()&&!this.entering&&angle) hanger.animate([{transform:`rotate(${angle}deg)`},{transform:`rotate(${-angle*.4}deg)`},{transform:'rotate(0deg)'}],{duration:600,easing:'ease-out'});
    }
    startSwing() {
      const strength=Number(this.config.scrollSwing ?? 4);
      if(this.swingFrame || !strength || !this.motion() || !this.inView || document.hidden || this.dialog.open) return;
      let previousTime=performance.now();
      this.lastSwingLeft ??= this.viewport.scrollLeft;
      const step=now=>{
        const dt=Math.min(.032,Math.max(.001,(now-previousTime)/1000));
        const left=this.viewport.scrollLeft;
        const speed=(left-this.lastSwingLeft)/dt;
        previousTime=now;
        this.lastSwingLeft=left;
        const target=Math.max(-strength,Math.min(strength,-speed*.012));
        let moving=this.gliding||Math.abs(speed)>1;
        this.springs.forEach(spring=>{
          if(!spring.node) return;
          // A damped spring pivots at the hook; scroll speed supplies the force.
          const mass=1+(spring.index%3)*.07;
          spring.velocity+=((target-spring.angle)*75/mass-spring.velocity*12)*dt;
          spring.angle+=spring.velocity*dt;
          spring.node.style.setProperty('--hr-scroll-angle',`${spring.angle.toFixed(3)}deg`);
          if(Math.abs(spring.angle)>.02||Math.abs(spring.velocity)>.08) moving=true;
        });
        if(moving) this.swingFrame=requestAnimationFrame(step);
        else this.stopSwing();
      };
      this.swingFrame=requestAnimationFrame(step);
    }
    stopSwing() {
      cancelAnimationFrame(this.swingFrame);
      this.swingFrame=null;
      this.lastSwingLeft=this.viewport?.scrollLeft;
      this.springs?.forEach(spring=>{
        spring.angle=0;
        spring.velocity=0;
        spring.node?.style.setProperty('--hr-scroll-angle','0deg');
      });
    }
    onClick(event) {
      const target=event.target.closest('button,a');
      if(!target || !this.contains(target)) return;
      if(target.matches('[data-rail-item]')) {
        if(this.dragged && event.detail!==0) { event.preventDefault(); this.dragged=false; return; }
        if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button>0) return;
        if(target.hasAttribute('data-collection-link')) return;
        if(typeof this.dialog.showModal!=='function') return;
        event.preventDefault();
        this.open(this.mobileLayout?Number(target.dataset.mobileIndex):this.items.indexOf(target));
      } else if(target.matches('[data-close]')) this.close();
      else if(target.matches('[data-go]')) this.go(Number(target.dataset.go));
      else if(target.matches('[data-previous]')) this.go(this.index-1);
      else if(target.matches('[data-next]')) this.go(this.index+1);
      else if(target.matches('[data-view]')) this.changeView(target.dataset.view);
      else if(target.matches('[data-detail-previous]')) this.stepProduct(-1);
      else if(target.matches('[data-detail-next]')) this.stepProduct(1);
    }
    stepProduct(direction) {
      for(let offset=1;offset<=this.items.length;offset++) {
        const index=(this.activeIndex+direction*offset+this.items.length)%this.items.length;
        if(!this.items[index].hasAttribute('data-collection-link')) { this.open(index); return; }
      }
    }
    updateControls() {
      if(!this.ready) return;
      const overflow=this.viewport.scrollWidth>this.viewport.clientWidth+4;
      this.controls.hidden=this.items.length<2||(!this.mobile.matches&&!overflow);
      this.resetTimer();
    }
    setDot(index) {
      this.index=index;
      [...this.dots.children].forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
    }
    findActive() {
      if(!this.ready||this.dialog.open||this.gliding) return;
      if(this.mobileLayout) {
        this.normalizeMobileLoop();
        this.updateMobileViews();
        return;
      }
      const center=this.viewport.getBoundingClientRect().left+this.viewport.clientWidth/2;
      let best=0,distance=Infinity;
      this.items.forEach((item,i)=>{const box=item.getBoundingClientRect();const d=Math.abs(box.left+box.width/2-center);if(d<distance){distance=d;best=i;}});
      this.setDot(best);
    }
    go(index) {
      this.finishEntrance();
      this.cancelGlide();
      index=(index+this.items.length)%this.items.length;
      if(this.mobileLayout) {
        let physical=index+(this.mobileLoop?2:0);
        if(this.mobileLoop && index===0 && this.index===this.items.length-1) physical=this.items.length+2;
        else if(this.mobileLoop && index===this.items.length-1 && this.index===0) physical=1;
        const left=(physical+(this.mobileLoop?-1:0))*this.mobilePitch;
        if(this.motion() && Math.abs(left-this.viewport.scrollLeft)>1) this.glideTo(left);
        else {
          this.viewport.scrollTo({left,behavior:'instant'});
          this.findActive();
        }
        this.resetTimer();
        return;
      }
      const item=this.items[index];
      const target=item.getBoundingClientRect();
      const view=this.viewport.getBoundingClientRect();
      const maximum=Math.max(0,this.viewport.scrollWidth-this.viewport.clientWidth);
      const left=Math.max(0,Math.min(maximum,this.viewport.scrollLeft+target.left-view.left-(view.width-target.width)/2));
      if(this.motion() && Math.abs(left-this.viewport.scrollLeft)>1) this.glideTo(left);
      else this.viewport.scrollTo({left,behavior:'instant'});
      this.setDot(index);
      this.resetTimer();
    }
    cancelGlide() {
      cancelAnimationFrame(this.glideFrame);
      this.gliding=false;
      this.viewport?.classList.remove('is-gliding');
    }
    glideTo(left) {
      const from=this.viewport.scrollLeft;
      const duration=Number(this.config.scrollDuration)||850;
      this.gliding=true;
      this.viewport.classList.add('is-gliding');
      this.lastSwingLeft=from;
      this.startSwing();
      let started;
      const step=now=>{
        if(!this.isConnected || !this.gliding) return;
        started ??= now;
        const progress=Math.min(1,(now-started)/duration);
        const eased=progress<.5?4*progress**3:1-((-2*progress+2)**3)/2;
        this.viewport.scrollLeft=from+(left-from)*eased;
        this.updateMobileViews();
        if(progress<1) this.glideFrame=requestAnimationFrame(step);
        else {
          this.cancelGlide();
          this.findActive();
          this.resetTimer();
        }
      };
      this.glideFrame=requestAnimationFrame(step);
    }
    advance() {
      if(this.mobileLayout) { this.go(this.index+1); return; }
      const maximum=this.viewport.scrollWidth-this.viewport.clientWidth;
      this.go(this.viewport.scrollLeft>=maximum-2?0:this.index+1);
    }
    resetTimer() {
      clearInterval(this.timer);
      if(!this.ready || !this.isConnected) return;
      if(!this.config.autoplay||!this.motion()||this.entering||this.gliding||this.scrolling||this.paused||!this.mobile.matches||!this.inView||document.hidden||this.dialog.open||this.hovered||this.focused||this.interacting||this.editorSelected||window.Shopify?.designMode||this.items.length<2||this.viewport.scrollWidth<=this.viewport.clientWidth+4) return;
      this.timer=setInterval(()=>this.advance(),this.config.interval*1000);
    }
    money(cents) {
      const options={style:'currency',currency:this.config.currency};
      if(this.config.currencyCode) options.currencyDisplay='code';
      return new Intl.NumberFormat(this.config.locale,options).format(Number(cents)/100);
    }
    message(text,error=false) {
      this.status.textContent=text;
      this.status.classList.toggle('is-error',error);
    }
    async open(index) {
      if(this.closing||this.pending) return;
      const item=this.items[index];
      if(!item || item.hasAttribute('data-collection-link')) return;
      this.cancelGlide();
      this.stopSwing();
      document.dispatchEvent(new CustomEvent('hanging-rail:opening',{detail:{source:this}}));
      this.activeIndex=index;
      this.activeItem=item;
      this.trigger=item;
      const data=JSON.parse(item.dataset.product);
      this.activeData=data;
      this.product=null;
      this.variant=null;
      this.front=item.dataset.front;
      this.back=item.dataset.back||'';
      this.currentView='front';
      this.querySelector('[data-title]').textContent=data.title;
      const productItems=this.items.filter(el=>!el.hasAttribute('data-collection-link'));
      this.querySelector('[data-counter]').textContent=`${String(productItems.indexOf(item)+1).padStart(2,'0')} / ${String(productItems.length).padStart(2,'0')}`;
      this.querySelectorAll('[data-detail-previous],[data-detail-next]').forEach(button=>{button.hidden=productItems.length<2;});
      this.querySelector('[data-price]').textContent=this.money(data.price);
      this.querySelector('[data-compare]').hidden=true;
      this.querySelector('[data-detail-note]').textContent=item.dataset.note||data.title;
      this.querySelector('[data-product-link]').href=data.url;
      this.querySelector('[data-view-cart]').hidden=true;
      this.querySelector('[data-options]').replaceChildren();
      this.form.hidden=Boolean(data.productPageOnly);
      this.addButton.disabled=true;
      this.addButton.textContent=this.labels.loading;
      this.querySelector('[data-variant-id]').value='';
      this.image.src=this.front;
      this.image.width=Number(item.dataset.frontWidth)||800;
      this.image.height=Number(item.dataset.frontHeight)||1000;
      this.image.alt=`${data.title} — ${this.labels.front}`;
      this.image.hidden=false;
      this.querySelector('[data-view="back"]').hidden=!this.back;
      this.querySelectorAll('[data-view]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.view==='front')));
      this.message(data.productPageOnly?this.labels.product_page_only:this.labels.loading);
      const wasOpen=this.dialog.open;
      if(!wasOpen) {
        this.previousOverflow=document.body.style.overflow;
        this.previousPadding=document.body.style.paddingRight;
        const gap=window.innerWidth-document.documentElement.clientWidth;
        document.body.style.overflow='hidden';
        if(gap>0) document.body.style.paddingRight=`${parseFloat(getComputedStyle(document.body).paddingRight)+gap}px`;
        this.locked=true;
        this.dialog.showModal();
        this.querySelector('[data-close]').focus({preventScroll:true});
      }
      this.dialog.scrollTop=0;
      this.resetTimer();
      if(this.motion()) {
        const origin=item.querySelector('.hr__picture--front').getBoundingClientRect();
        const destination=this.image.getBoundingClientRect();
        if(origin.width&&destination.width) {
          const dx=origin.left+origin.width/2-destination.left-destination.width/2;
          const dy=origin.top+origin.height/2-destination.top-destination.height/2;
          this.image.animate([{transform:`translate(${dx}px,${dy}px) scale(${origin.width/destination.width},${origin.height/destination.height})`,opacity:.5},{transform:'none',opacity:1}],{duration:this.config.duration+180,easing:'cubic-bezier(.2,.7,.2,1)'});
        }
        this.querySelector('[data-information]').animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'none'}],{duration:this.config.duration,easing:'ease-out'});
      }
      const version=++this.loadVersion;
      if(data.productPageOnly) return;
      try {
        const url=new URL(data.url,location.origin);
        url.search='';url.hash='';url.pathname=url.pathname.replace(/\/$/,'')+'.js';
        if(url.origin!==location.origin) throw new Error('Invalid product URL');
        let product=this.cache.get(url.href);
        if(!product) {
          const response=await fetch(url.href,{headers:{Accept:'application/json'},credentials:'same-origin',signal:this.abort.signal});
          if(!response.ok) throw new Error('Product unavailable');
          product=await response.json();
          if(!Array.isArray(product.variants)||!product.variants.length) throw new Error('Product has no variants');
          this.cache.set(url.href,product);
        }
        if(version!==this.loadVersion||!this.dialog.open||!this.isConnected) return;
        this.product=product;
        this.renderOptions();
        this.updateVariant();
      } catch(error) {
        if(error.name==='AbortError'||version!==this.loadVersion) return;
        this.addButton.textContent=this.labels.unavailable;
        this.message(this.labels.load_error,true);
      }
    }
    renderOptions() {
      const selected=this.product.variants.find(v=>String(v.id)===String(this.activeData.variantId)&&v.available)||this.product.variants.find(v=>v.available)||this.product.variants[0];
      this.initialVariant=selected;
      const groups=this.querySelector('[data-options]');
      groups.replaceChildren();
      this.optionNames=this.product.options.map(option=>typeof option==='string'?option:option.name);
      if(this.product.variants.length===1&&selected.title==='Default Title') return;
      this.optionNames.forEach((name,position)=>{
        const fieldset=document.createElement('fieldset');fieldset.className='hr__option';
        const legend=document.createElement('legend');legend.textContent=name;fieldset.append(legend);
        const values=document.createElement('div');values.className='hr__values';fieldset.append(values);
        [...new Set(this.product.variants.map(v=>v.options[position]))].forEach(value=>{
          const label=document.createElement('label');label.className='hr__choice';
          const input=document.createElement('input');input.type='radio';input.name=`${this.id}-option-${position}`;input.value=value;input.dataset.option=String(position);input.checked=selected.options[position]===value;
          const span=document.createElement('span');span.textContent=value;
          label.append(input,span);values.append(label);
        });
        groups.append(fieldset);
      });
    }
    updateVariant() {
      if(!this.product||this.pending) return;
      const inputs=[...this.querySelectorAll('[data-option]:checked')];
      const selected=inputs.length?inputs.map(input=>input.value):this.initialVariant.options;
      this.variant=this.product.variants.find(v=>v.options.every((value,i)=>selected[i]===value));
      const variant=this.variant;
      this.querySelector('[data-variant-id]').value=variant?.id||'';
      this.addButton.disabled=!variant?.available;
      this.addButton.textContent=!variant?this.labels.unavailable:!variant.available?this.labels.sold_out:this.labels.add;
      this.querySelector('[data-price]').textContent=variant?this.money(variant.price):this.labels.unavailable;
      const compare=this.querySelector('[data-compare]');
      compare.hidden=!(variant?.compare_at_price>variant?.price);
      compare.textContent=compare.hidden?'':this.money(variant.compare_at_price);
      const link=new URL(this.activeData.url,location.origin);
      if(variant) link.searchParams.set('variant',variant.id);
      this.querySelector('[data-product-link]').href=link.href;
      this.querySelector('[data-view-cart]').hidden=true;
      this.querySelectorAll('[data-option]').forEach(input=>{
        const position=Number(input.dataset.option);
        const available=this.product.variants.some(v=>v.available&&v.options[position]===input.value&&v.options.every((value,i)=>i>=position||value===selected[i]));
        input.closest('label').classList.toggle('is-unavailable',!available);
        input.setAttribute('aria-label',`${input.value}${available?'':`, ${this.labels.sold_out}`}`);
      });
      this.message(!variant?this.labels.unavailable:!variant.available?this.labels.sold_out:'',!variant||!variant.available);
      this.front=this.activeItem.dataset.front;
      this.back=this.activeItem.dataset.back||'';
      if(this.config.variantImages&&variant?.featured_image?.src) {
        const initialSrc=this.initialVariant?.featured_image?.src;
        if(variant.featured_image.src!==initialSrc) {this.front=variant.featured_image.src;this.back='';}
      }
      this.querySelector('[data-view="back"]').hidden=!this.back;
      this.changeView(this.back?this.currentView:'front',false);
    }
    changeView(view,animate=true) {
      if(view==='back'&&!this.back) return;
      this.currentView=view;
      this.image.src=view==='back'?this.back:this.front;
      this.image.alt=`${this.activeData.title} — ${this.labels[view]}`;
      this.querySelectorAll('[data-view]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.view===view)));
      if(animate&&this.motion()) this.image.animate([{transform:'perspective(1000px) rotateY(-12deg)',opacity:.3},{transform:'none',opacity:1}],{duration:this.config.duration,easing:'ease-out'});
    }
    async close(immediate=false) {
      if(!this.dialog?.open||this.closing) {if(immediate)this.unlock();return;}
      this.closing=true;
      this.loadVersion++;
      if(this.motion()&&!immediate&&this.activeItem?.isConnected) {
        const start=this.image.getBoundingClientRect();
        const end=this.activeItem.querySelector('.hr__picture--side').getBoundingClientRect();
        if(start.width&&end.width) {
          const animation=this.image.animate([{transform:'none',opacity:1},{transform:`translate(${end.left+end.width/2-start.left-start.width/2}px,${end.top+end.height/2-start.top-start.height/2}px) scale(${end.width/start.width},${end.height/start.height})`,opacity:0}],{duration:Math.min(320,this.config.duration),easing:'ease-in',fill:'forwards'});
          await animation.finished.catch(()=>{});
          animation.cancel();
        }
      }
      this.dialog.close();
      this.unlock();
      this.closing=false;
      if(!immediate&&this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
      this.resetTimer();
    }
    unlock() {
      if(!this.locked) return;
      document.body.style.overflow=this.previousOverflow;
      document.body.style.paddingRight=this.previousPadding;
      this.locked=false;
    }
    async addToCart() {
      if(this.pending||!this.variant?.available) return;
      const restoreButtonFocus=document.activeElement===this.addButton;
      this.pending=true;
      this.addButton.disabled=true;
      this.addButton.textContent=this.labels.adding;
      this.form.setAttribute('aria-busy','true');
      this.querySelectorAll('[data-option]').forEach(input=>input.disabled=true);
      this.message('');
      const variantId=this.variant.id;
      const operation=this.loadVersion;
      const root=window.Shopify?.routes?.root||this.config.root||'/';
      const drawer=this.config.cartMode==='drawer'?document.querySelector('cart-drawer'):null;
      let sections=[];
      if(drawer&&typeof drawer.getSectionsToRender==='function'&&typeof drawer.renderContents==='function') {
        try {sections=drawer.getSectionsToRender().map(section=>section.id).filter(Boolean).slice(0,5);}catch {sections=[];}
      }
      const payload={items:[{id:variantId,quantity:1}]};
      if(sections.length){payload.sections=sections;payload.sections_url=location.pathname;}
      try {
        const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify(payload)});
        const result=await response.json();
        if(!response.ok||result.status) throw new Error(result.description||result.message||this.labels.cart_error);
        document.dispatchEvent(new CustomEvent('hanging-rail:cart-added',{detail:{variantId,quantity:1,response:result,sectionId:this.dataset.sectionId}}));
        if(this.config.cartMode==='page') {location.assign(this.config.cartUrl);return;}
        if(drawer&&sections.length&&result.sections&&sections.every(id=>typeof result.sections[id]==='string')) {
          try {
            await this.close(true);
            drawer.setActiveElement?.(this.trigger);
            drawer.renderContents({...result,id:result.items?.[0]?.id||variantId});
            return;
          } catch {location.assign(this.config.cartUrl);return;}
        }
        if(this.config.cartMode==='drawer') {location.assign(this.config.cartUrl);return;}
        if(operation===this.loadVersion&&this.isConnected) {
          this.message(this.labels.added);
          this.querySelector('[data-view-cart]').hidden=false;
        }
      } catch(error) {
        if(operation===this.loadVersion&&this.isConnected) this.message(error.message||this.labels.cart_error,true);
      } finally {
        this.pending=false;
        this.form?.removeAttribute('aria-busy');
        this.querySelectorAll('[data-option]').forEach(input=>input.disabled=false);
        if(this.addButton){this.addButton.disabled=!this.variant?.available;this.addButton.textContent=this.variant?.available?this.labels.add:this.labels.sold_out;}
        if(restoreButtonFocus&&this.dialog?.open&&operation===this.loadVersion&&document.activeElement===document.body) this.addButton.focus({preventScroll:true});
      }
    }
  }
  customElements.define('hanging-collection-rail',HangingCollectionRail);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
